import { render, staticRenderFns } from "./EditCommentModal.vue?vue&type=template&id=cbbb84c4&scoped=true&"
import script from "./EditCommentModal.vue?vue&type=script&lang=js&"
export * from "./EditCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCommentModal.vue?vue&type=style&index=0&id=cbbb84c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb84c4",
  null
  
)

export default component.exports